import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    textAlign: 'center',
    padding: ['40px 0px 0px', '100px 0px 0px'],
  },
  innerContainer: {
    marginBottom: ['0px', '100px'],
  },
  title: {
    marginBottom: ['12px', '24px'],
    padding: ['0px 20px', 'initial'],
  },
  subtitle: {
    marginBottom: ['26px', '74px'],
    padding: ['0px 20px', 'initial'],
    maxWidth: ['324px', '917px'],
    marginX: 'auto',
  },
  repeaterContainer: {
    flexDirection: ['column', 'row'],
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  iconColor: {
    '.paragraph-color': {
      color: 'indigo.100',
    },
  },
};
